import { TouchEvent } from "react";
import { useAtom } from "jotai";
import { WindowWidthAtom } from "@/hooks/dim-hook";

interface Props {
  children: any;
  isRtl: boolean;
  onClose: () => void;
  width?: number;
}

const DetectSwipeClose: React.FC<Props> = ({
  isRtl,
  onClose,
  children,
  width = 279,
}) => {
  const [w] = useAtom(WindowWidthAtom);
  const onTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    if (
      (!isRtl && e.targetTouches[0].clientX < width) ||
      (isRtl && e.targetTouches[0].clientX > w - width)
    )
      return;
    onClose();
  };

  return (
    <div onTouchStart={onTouchStart} style={{ display: "contents" }}>
      {children}
    </div>
  );
};

export default DetectSwipeClose;
